module.exports = __webpack_public_path__ + "img/logowhite.343057f7.png";